import { useQuery } from '@apollo/client';

import GetVspPageV2Data from 'bundles/enterprise-learning-path-description-page/queries/GetSkillPathwayQueryV2.graphql';
import type {
  QueryVerifiedSkillPathsPageQuery,
  QueryVerifiedSkillPathsPageQueryVariables,
} from 'bundles/enterprise-learning-path-description-page/queries/__generated__/GetSkillPathwayQueryV2';

export const useVspPageV2Data = (courseIds: string[]) => {
  const { data, loading } = useQuery<QueryVerifiedSkillPathsPageQuery, QueryVerifiedSkillPathsPageQueryVariables>(
    GetVspPageV2Data,
    {
      variables: {
        input: { courseIds },
      },
      context: {
        clientName: 'gatewayGql',
      },
      skip: !courseIds.length,
    }
  );
  return { data, loading };
};
